import { Dispatch } from 'redux';
import {
  PONTO_VENDA_FAIL,
  PONTO_VENDA_LOADING,
  PONTO_VENDA_SUCCESS,
  PONTO_VENDA_FILTER,
  PontoVendaDispatchTypes,
} from './PontoVendaTypes';
import api from '../../services/api';

export const GetPontosVenda =
  () => async (dispatch: Dispatch<PontoVendaDispatchTypes>) => {
    try {
      dispatch({ type: PONTO_VENDA_LOADING });

      const response = await api.get(
        `${process.env.REACT_APP_URL_GET_PONTOS_VENDA}`);

      dispatch({
        type: PONTO_VENDA_SUCCESS,
        payload: response.data.dadosProcessamento,
      });
    } catch (error) {
      dispatch({ type: PONTO_VENDA_FAIL, payload: error.Message });
    }
  };

export const FilterPontosVenda =
  (filter: string, type: string) =>
  (dispatch: Dispatch<PontoVendaDispatchTypes>) => {
    if (type === 'N') {
      dispatch({ type: PONTO_VENDA_FILTER, payload: { filter, type: 'N' } });
    } else if (type === 'C') {
      dispatch({ type: PONTO_VENDA_FILTER, payload: { filter, type: 'C' } });
    }
  };
